import { render, staticRenderFns } from "./PostTikTok.vue?vue&type=template&id=0a6889aa&"
import script from "./PostTikTok.vue?vue&type=script&lang=js&"
export * from "./PostTikTok.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports